import React from "react";
import Navigation from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/AlliancesAndTestimonials.css";

// Speaker Image (replace file if needed)
import speakerImage from "../assests/images/oscar.jpg";

const AlliancesAndTestimonials = () => {
  return (
    <div className="alliances-page">
      <Navigation />

      {/* Hero Section */}
      <section className="alliances-hero">
        <h1>Alliances & Testimonials</h1>
        <p>
          Trusted Partnerships Built on Transparency, Operational Excellence,
          and Long-Term Success
        </p>
      </section>

      {/* Testimonial */}
      <section className="testimonial-section">
        <div className="testimonial-card">
          {/* Speaker Image */}
          <div className="testimonial-image">
            <img src={speakerImage} alt="Oscar Valdelvira" />
          </div>

          {/* Content */}
          <div className="testimonial-content">
            <span className="quote-icon">“</span>

            <p className="testimonial-text">
              Cloudare has proven to be a strong strategic partner and our
              alliance has been defined by transparent communication,
              operational excellence, and a shared focus on long-term success.
              <br />
              <br />
              Working with their team has been consistently smooth and
              productive, with a clear commitment to joint outcomes and mutual
              growth.
              <br />
              <br />
              Based on my experience, I would recommend Cloudare without
              hesitation to any organization seeking a collaborative and
              high-performing partner.
            </p>

            <div className="testimonial-footer">
              <h4>Oscar Valdelvira</h4>
              <span>Partnership & Alliance</span>
              <span className="company-tag">
                Testimonial from <strong>Marosa</strong> – E-Invoicing Partner
              </span>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AlliancesAndTestimonials;
